import Breadcrumb from "./breadcrumb";

export default Breadcrumb;
